<template>
  <router-view />
  <SToast />
</template>

<script setup lang="ts">
import { SToast } from '@synergy/ui-kit-vue3';
import { onMounted } from 'vue';

onMounted(() => {
  document.title = 'Мое портфолио';
});
</script>

<style lang="scss">

</style>
